import {createStore} from 'zustand-x';

export type QueueCountState = {
    count: number,
}

const initialState: QueueCountState = {
    count: 0,
}

export const queueCountSlice = createStore(initialState, {name: 'queueCount'})
    .extendActions(({set, get}) => ({
        increment: (n = 1) => set('count', get('count') + n),
        decrement: (n = 1) => set('count', Math.max(0, get('count') - n)),
    }));
